export default {
  title: 'Nuovo marchio',
  tabs: {
    general: 'Generale',
    branding: 'Branding',
    scripts: 'Script',
    tracking: 'Tracking',
    domain: 'Dominio',
  },
  fields: {
    name: {
      label: 'Nome',
      placeholder: 'Nome del marchio',
    },
    slug: {
      label: 'Sottodominio',
      placeholder: 'Sottodominio del marchio',
      hint: "Lettere minuscole, numeri e trattini. Insieme al dominio del negozio forma l'indirizzo del negozio.",
      preview: 'Indirizzo negozio: {{url}}',
      availability: {
        taken: 'Un altro marchio usa già questo sottodominio su questo dominio del negozio.',
        reserved: 'Questo sottodominio è riservato. Scegline un altro.',
        invalid_label:
          'Su questo dominio del negozio il sottodominio può contenere solo lettere minuscole, numeri e trattini, deve iniziare e finire con una lettera o un numero e può avere al massimo 63 caratteri.',
        taken_elsewhere: 'Un marchio su un altro dominio del negozio usa già questo sottodominio. Scegline un altro.',
        format: 'Usa solo lettere, numeri, trattini e underscore.',
        unavailable: 'Questo sottodominio non è disponibile. Scegline un altro.',
      },
    },
    shop_domain_id: {
      label: 'Dominio negozio',
      placeholder: 'Seleziona un dominio negozio',
      move_warning: {
        title: 'Questo cambia l’indirizzo del negozio usato dai clienti',
        description:
          'Dopo il salvataggio, il negozio sarà su {{url}}. Codici QR, volantini e link già stampati o condivisi con il vecchio indirizzo smetteranno di funzionare.',
      },
    },
    lieferando_url: {
      label: 'Lieferando URL',
      placeholder: 'URL del ristorante su Lieferando',
    },
    primary_color: {
      label: 'Colore principale',
    },
    logo: {
      label: 'Logo',
    },
    image: {
      label: 'Immagine',
    },
    companies: {
      label: 'Ristoranti',
    },
    noscripts: {
      description: "Inserisci codice subito dopo l'apertura del body",
    },
    facebook_pixel: {
      label: 'Facebook Pixel',
    },
    facebook_conversion_api_access_token: {
      label: 'Facebook Conversion Access Token',
    },
    google_analytics_id: {
      label: 'Google Analytics ID',
    },
    google_ads_conversion_label_id: {
      label: 'Etichetta di conversione Google Ads',
    },
    // Named in the modal's error summary when the domain is refused.
    online_shop_domain: {
      label: 'Dominio proprio per il negozio online',
    },
  },
  buttons: {
    save: 'Salva',
    close: 'Chiudi',
    sync_from_lieferando: 'Sincronizza da Lieferando',
  },
  toasts: {
    changes_saved_successfully: 'Modifiche salvate con successo!',
    failed_to_update_company_slug: 'Impossibile aggiornare lo slug per {{name}}',
    failed_to_sync_lieferando: 'Sincronizzazione da Lieferando fallita',
    successfully_synced_lieferando: 'Dati sincronizzati da Lieferando con successo',
    failed_to_load_shop_domains: 'Impossibile caricare i domini del negozio.',
  },
};
